(function () {
  function init() {
    document.querySelectorAll('product-variants').forEach(function (wrapper) {
      var assemblyCards = wrapper.querySelectorAll('.product-variant-option--assembly');
      if (!assemblyCards.length) return;

      var jsonSel = wrapper.dataset.jsonSelector;
      var jsonEl = jsonSel ? document.querySelector(jsonSel) : null;
      if (!jsonEl) return;

      var data;
      try { data = JSON.parse(jsonEl.textContent); } catch (e) { return; }

      var fieldsets = Array.from(wrapper.querySelectorAll('fieldset'));
      if (!fieldsets.length) return;

      var assemblyFieldset = assemblyCards[0].closest('fieldset');
      var assemblyIndex = fieldsets.indexOf(assemblyFieldset);
      if (assemblyIndex === -1) return;

      function formatMoney(cents) {
        if (window.Shopify && Shopify.formatMoney && window.money_format) {
          return Shopify.formatMoney(cents, window.money_format);
        }
        return '$' + (cents / 100).toFixed(2);
      }

      function formatDelta(cents) {
        var s = formatMoney(cents);
        return s.replace(/\.00\b/, '');
      }

      function update() {
        var selections = fieldsets.map(function (fs) {
          var checked = fs.querySelector('input[type="radio"]:checked');
          return checked ? checked.value : null;
        });

        var cards = assemblyFieldset.querySelectorAll('.product-variant-option--assembly');
        var baselinePrice = null;

        cards.forEach(function (card, idx) {
          var input = card.querySelector('input[type="radio"]');
          if (!input) return;
          var assemblyValue = input.value;

          var variant = data.variants.find(function (v) {
            var opts = v.options || [v.option1, v.option2, v.option3];
            for (var i = 0; i < selections.length; i++) {
              var want = i === assemblyIndex ? assemblyValue : selections[i];
              if (opts[i] !== want) return false;
            }
            return true;
          });

          var priceEl = card.querySelector('[data-assembly-price]');
          var helperEl = card.querySelector('[data-assembly-helper]');
          var isBaseline = input.dataset.assemblyBaseline === 'true';

          if (variant) {
            var price = variant.price;
            if (priceEl) priceEl.textContent = formatMoney(price);
            if (isBaseline) {
              baselinePrice = price;
              if (helperEl) helperEl.textContent = 'Ships fast · assembles in under an hour';
            } else if (helperEl) {
              var delta = baselinePrice == null ? 0 : price - baselinePrice;
              helperEl.textContent = delta > 0
                ? 'Ready to install · +' + formatDelta(delta)
                : 'Ready to install';
            }
          } else {
            if (priceEl) priceEl.textContent = '—';
            if (helperEl) helperEl.textContent = isBaseline ? 'Ships fast · assembles in under an hour' : 'Ready to install';
          }
        });

        updateShipBadge(selections[assemblyIndex]);
      }

      function updateShipBadge(selectedAssembly) {
        var badge = document.querySelector('[data-ship-badge]');
        if (!badge) return;
        var key = (selectedAssembly || '').toLowerCase().replace(/[\s-]/g, '');
        var assembled = key.indexOf('preassembl') !== -1;
        var titleEl = badge.querySelector('[data-ship-title]');
        var subEl = badge.querySelector('[data-ship-sub]');
        if (titleEl) titleEl.textContent = badge.getAttribute(assembled ? 'data-ship-title-assembled' : 'data-ship-title-flatpack');
        if (subEl) subEl.textContent = badge.getAttribute(assembled ? 'data-ship-sub-assembled' : 'data-ship-sub-flatpack');
      }

      wrapper.addEventListener('change', function (e) {
        if (e.target && e.target.matches('input[type="radio"]')) {
          setTimeout(update, 0);
        }
      });

      update();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
